import { usePost } from '@/lib/useData';

/**
 * Récupère les données d'un endpoint analytics POUR CHAQUE famille sélectionnée,
 * en réutilisant le paramètre `segment` déjà géré côté backend (apply_filters).
 *
 * Appelle TOUJOURS les 3 requêtes (ensemble / régulier / parrainage) — nombre fixe
 * de hooks — mais n'active que celles qui sont sélectionnées (et, pour les familles
 * parrainage/régulier, uniquement si le parrainage est activé). React Query met en
 * cache chaque famille séparément (clé = [path, body]).
 *
 * @returns { byKey: { ensemble, regulier, parrainage }, isLoading }
 */
export function useSegmentQueries(path, body, extra, selected, { parrainageOn, seuil }) {
  const hasAssoc = !!body?.association;
  const base = { ...body, ...extra, parrainage_seuil: seuil };

  const ensemble = usePost(path, { ...base, segment: null },
    hasAssoc && selected.includes('ensemble'));
  const regulier = usePost(path, { ...base, segment: 'regulier' },
    hasAssoc && parrainageOn && selected.includes('regulier'));
  const parrainage = usePost(path, { ...base, segment: 'parrainage' },
    hasAssoc && parrainageOn && selected.includes('parrainage'));

  const byKey = { ensemble, regulier, parrainage };
  const isLoading = selected.some((k) => byKey[k] && byKey[k].isLoading);
  return { byKey, isLoading };
}
